import { createFileRoute } from '@tanstack/react-router';
import { TicketDetailPage } from '@/features/it-service/pages';

export const Route = createFileRoute('/it-service/tickets/$ticketId')({
  component: TicketDetailPage,
});
